import React, { useState } from 'react'
import '../css/denunciacgm.scss'
import Menu from './Menu'

export default function App() {
    const [usuarioLogado, setUsuarioLogado] = useState({})
    const [chamador, setChamador] = useState('')
    const [formularioEmPauta, setFormularioEmPauta] = useState('')
    const [anonimato, setAnonimato] = useState('')
    const [linhaDoTempo, setLinhaDoTempo] = useState({})
    const [denuncia, setDenuncia] = useState('')
    const [dadosPessoais, setDadosPessoais] = useState({})
    const [local, setLocal] = useState('')
    const [dataAcontecimento, setDataAcontecimento] = useState('')
    const [pessoasEnvolvidas, setPessoasEnvolvidas] = useState([])
    const [links, setLinks] = useState([])
    const [anexosDto, setAnexosDto] = useState([])
    const [conteudo, setConteudo] = useState({})
    const [protocoloValido, setProtocoloValido] = useState(false)
    const [showDenuncia, setShowDenuncia] = useState(false)
    const [mensagem, setMensagem] = useState()
    const [showSpinner, setShowSpinner] = useState(true)
    const [denunciaComplementar, setDenunciaComplementar] = useState({})
    const [correspondenciaEntregue, setCorrespondenciaEntregue] = useState({}) 
    const [visualizarProvidencias, setVisualizarProvidencias] = useState({}) 
    const [complementacao, setComplementacao] = useState('')
    const [renderizarDenuncia, setRenderizarDenuncia] = useState({})

    const iniciarCampos = (iniciarPrincipal = false, iniciarOutros = false) => {
        if (iniciarPrincipal) {
            setUsuarioLogado({ login:'', senha:'', nome:'', logado:false })
            setDenuncia('')
            setDadosPessoais({ nome:'', telefone:'', email:'' })
            setLocal({ logradouro:'',numero:'', complemento:'', bairro:'', municipio:'',cep:'' })
            setDataAcontecimento('')
            setPessoasEnvolvidas([])
            setLinks([])
            setAnexosDto([])
        } 

        if (iniciarOutros) {
            setDenunciaComplementar({ show:false })
            setRenderizarDenuncia({ denuncia:'', show:false })
            setCorrespondenciaEntregue({ protocolo:'', show:false })
            setVisualizarProvidencias({ show:false }) 
        }
    }

    const atualizarAnexos = anexo => {
        const anexos = [].concat(anexosDto)
        anexos.push(anexo)
        setAnexosDto([])
        setAnexosDto(anexos)
    }

    const removerAnexos = (id,nomeArquivo) => {
        const anexos = []
        for (let i=0; i<anexosDto.length; i++) {
            if (anexosDto[i].nomeArquivo === nomeArquivo) {
                document.getElementById(id).value = ""
                continue
            }
            anexos.push(anexosDto[i])
        }
        setAnexosDto(anexos)
    }

    const atuItens = (
        emPauta,
        protocolo,
        contato,
        local,
        dataHora,
        envolvidos,
        narrativa,
        postagens,
        enviarArquivos,
        submit,
        correspondenciaEntregue,
        visualizarProvidencias,
        login
    ) => {
        setLinhaDoTempo({ 
            emPauta,
            protocolo,
            contato,
            local,
            dataHora,
            envolvidos,
            narrativa,
            postagens,
            enviarArquivos,
            submit,
            correspondenciaEntregue,
            visualizarProvidencias, 
            login
        })
    }

    const atuLinhaDoTempo = emPauta => {
        if (emPauta === 'protocolo') {
            atuItens(emPauta,false,false,false,false,false,false,false,false,false,false,false,false)
        } else if (emPauta === 'contato') {
            atuItens(emPauta,true,false,false,false,false,false,false,false,false,false,false,false)
        } else if (emPauta === 'local') {
            atuItens(emPauta,true,true,false,false,false,false,false,false,false,false,false,false)
        } else if (emPauta === 'dataHora') {
            atuItens(emPauta,true,true,true,false,false,false,false,false,false,false,false,false)
        } else if (emPauta === 'envolvidos') {
            atuItens(emPauta,true,true,true,true,false,false,false,false,false,false,false,false)
        } else if (emPauta === 'narrativa') {
            atuItens(emPauta,true,true,true,true,true,false,false,false,false,false,false,false)
        } else if (emPauta === 'postagens') {
            atuItens(emPauta,true,true,true,true,true,true,false,false,false,false,false,false)
        } else if (emPauta === 'enviarArquivos') {
            atuItens(emPauta,true,true,true,true,true,true,true,false,false,false,false,false)
        } else if (emPauta === 'submit') {
            atuItens(emPauta,true,true,true,true,true,true,true,true,false,false,false,false)
        } else  if (emPauta === 'correspondenciaEntregue') {
            atuItens(emPauta,true,true,true,true,true,true,true,true,true,false,false,false)
        } else if (emPauta === 'visualizarProvidencias') {
            atuItens(emPauta,true,true,true,true,true,true,true,true,true,true,false,false)
        } else if (emPauta === 'login') {
            atuItens(emPauta,true,true,true,true,true,true,true,true,true,true,true,false)
    	}
    }

    return (
        <Menu 
            usuarioLogado={ usuarioLogado } setUsuarioLogado={ setUsuarioLogado }
            chamador={ chamador } setChamador={ setChamador }
            formularioEmPauta={ formularioEmPauta} setFormularioEmPauta={ setFormularioEmPauta }
            iniciarCampos={ iniciarCampos }
            anonimato={ anonimato } setAnonimato={ setAnonimato }
            linhaDoTempo={ linhaDoTempo } atuLinhaDoTempo={ atuLinhaDoTempo }
            showSpinner={ showSpinner } setShowSpinner={ setShowSpinner }
            mensagem={ mensagem } setMensagem={ setMensagem }
            showDenuncia={ showDenuncia } setShowDenuncia={ setShowDenuncia }
            denuncia={ denuncia } setDenuncia={ setDenuncia }
            dadosPessoais={ dadosPessoais } setDadosPessoais={ setDadosPessoais }
            local={ local } setLocal={ setLocal }
            dataAcontecimento={ dataAcontecimento} setDataAcontecimento={ setDataAcontecimento }
            pessoasEnvolvidas={ pessoasEnvolvidas} setPessoasEnvolvidas={ setPessoasEnvolvidas }
            links={ links} setLinks={ setLinks }
            anexosDto={ anexosDto } setAnexosDto={ setAnexosDto }
            conteudo={ conteudo } setConteudo={ setConteudo }
            protocoloValido={ protocoloValido } setProtocoloValido={ setProtocoloValido }
            atualizarAnexos={ atualizarAnexos} removerAnexos={ removerAnexos }
            showDenuncia={ showDenuncia } setShowDenuncia={ setShowDenuncia }
            denunciaComplementar={ denunciaComplementar }
            setDenunciaComplementar={ setDenunciaComplementar } 
            correspondenciaEntregue={ correspondenciaEntregue }
            setCorrespondenciaEntregue={ setCorrespondenciaEntregue }
            visualizarProvidencias={ visualizarProvidencias } 
            setVisualizarProvidencias={ setVisualizarProvidencias}
            complementacao={ complementacao } setComplementacao={ setComplementacao }
            renderizarDenuncia={ renderizarDenuncia } setRenderizarDenuncia={ setRenderizarDenuncia }
        />
    )
}